import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {

    const code = route.params['code'];

    // 1) Authenticate: existing session, or a one-time code login.
    let authenticated = false;
    if (this.loginService.UID) { // If ls has UID we assume success login
      authenticated = true;
    } else if (code) {
      authenticated = await this.loginService.loginWithCode(code);
    }
    if (!authenticated) {
      return this.router.createUrlTree(['/']); // Kick out in case no login
    }

    // 2) Authorize: the module this route belongs to must be permitted for the
    // user (item 5). loginWithCode awaits permissions load, so premissions is set.
    const required = this.requiredPermissions(route);
    if (required.length && !this.hasAnyPermission(required)) {
      return this.router.createUrlTree(['/no-access']);
    }
    return true;
  }

  // Maps a route to the permission flag(s) that grant access. `settings` needs
  // any one module; module routes need their own flag; others (attendance, main)
  // are auth-only.
  private requiredPermissions(route: ActivatedRouteSnapshot): string[] {
    const path = route.routeConfig?.path || '';
    if (path.startsWith('appointments')) return ['Appointments'];
    if (path.startsWith('billing')) return ['Billings'];
    if (path.startsWith('questionnaires')) return ['Questionnaires'];
    if (path.startsWith('financial')) return ['FinancialReports'];
    if (path.startsWith('settings')) return ['Appointments', 'Billings', 'Questionnaires', 'FinancialReports'];
    return [];
  }

  private hasAnyPermission(flags: string[]): boolean {
    const p = this.loginService.premissions;
    if (!p) return false;
    return flags.some((flag) => !!p[flag]);
  }
}
